class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class InputDisclosure extends DetailsDisclosure {
  constructor() {
    super();

    this.summary = this.querySelector('summary');
    this.label   = this.querySelector('[data-label]');
    this.input   = this.querySelector('input[type="hidden"]');
    this.options = this.querySelectorAll('[data-value]');

    if (!this.input) {
      console.warn('InputDisclosure: hidden input not found', this);
      return;
    }

    this.options.forEach(option => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        this.select(option.dataset.value);
      });
    });
  }

  select(value) {
    // Update hidden input
    this.input.value = value;

    // Update visible label
    this.label.textContent = value;

    // Mark component as filled
    this.toggleAttribute('data-has-value', !!value);

    // Mark selected option (ARIA + UI hook)
    this.options.forEach(option => {
      option.toggleAttribute(
        'aria-selected',
        option.dataset.value === value
      );
    });

    // Accessibility
    this.summary.setAttribute('aria-expanded', 'false');

    // Close disclosure
    this.close();
  }

  connectedCallback() {
    if (this.input?.value) {
      this.toggleAttribute('data-has-value', true);
      this.label.textContent = this.input.value;
    }
  }
}

customElements.define('input-disclosure', InputDisclosure);